import type { IconNode } from '../types';

/**
 * @name socks
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNOS42IDIwLjQgOSAyMWEzLjM4IDMuMzggMCAxIDEtNC45LTQuOWwzLjUtMy41QzguNCAxMS42IDkgMTAuNCA5IDlWM2MwLS42LjQtMSAxLTFoMTBjLjYgMCAxIC40IDEgMXYxMGE1LjE1IDUuMTUgMCAwIDEtMS41IDMuNkwxNSAyMWEzLjM4IDMuMzggMCAxIDEtNC45LTQuOWwzLjUtMy41Yy44LTEgMS40LTIuMiAxLjQtMy42VjIiIC8+CiAgPHBhdGggZD0iTTkgNmgxMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/socks
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const socks: IconNode = [
  [
    'path',
    {
      d: 'M9.6 20.4 9 21a3.38 3.38 0 1 1-4.9-4.9l3.5-3.5C8.4 11.6 9 10.4 9 9V3c0-.6.4-1 1-1h10c.6 0 1 .4 1 1v10a5.15 5.15 0 0 1-1.5 3.6L15 21a3.38 3.38 0 1 1-4.9-4.9l3.5-3.5c.8-1 1.4-2.2 1.4-3.6V2',
      key: '7wkxk6',
    },
  ],
  ['path', { d: 'M9 6h12', key: 'x4ogtv' }],
];

export default socks;
